import { Component, OnInit } from '@angular/core';
import { AdminThirtyEightyService } from '../admin-thirty-eighty-services/admin-thirty-eighty-service.service';
import { SurveryEvaluationService } from '../survey-thirtyeighty/survery-evaluation.service';
import {Router} from '@angular/router';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';
import AppConstants from 'src/app/shared/common-components/AppConstants';
import * as _ from 'lodash';

@Component({
    selector: 'app-admin-employee-thirtyeighty',
    templateUrl: './admin-employee-thirtyeighty.component.html',
    styleUrls: ['./admin-employee-thirtyeighty.component.css'],
    standalone: false
})

export class AdminEmployeeThirtyEightyComponent implements OnInit {
  emplLastName: string;
  rowData: any;
  columnDefs: any;
  listSurveybyLastName: any;
  overlayNoRowsTemplate: any;
  cleanData: any;
  defaultColDef: any;
  paginationPageSize: any;
  // private gridApi;

  constructor(private adminThirtyEightyService: AdminThirtyEightyService,
              private surveryEvaluationService: SurveryEvaluationService,
              private loader: LoadingService,
              private router: Router,
              private alertService: AlertService) {
   this.initializedColDef();
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No results found. Please adjust your filters.</span>';
  }

  ngOnInit() {
    this.adminThirtyEightyService.Data.subscribe(data => {
      this.loader.show();
      this.emplLastName = _.startCase(_.toLower(data));
      this.loader.hide();
      this.getSurveyData();
    }, error => {
      this.loader.hide();
      this.alertService.error('Unable to load Survey based on Employee Last Name. Please Try again!');
    });
  }

  onSurveyNo(data: any) {
    this.router.navigate(['/evaluationForm'],  { queryParams: { adminSurveyNo: data.surveyNumber } });
  }

  getSurveyData() {
    this.surveryEvaluationService.getSurveyByEmplLastName(this.emplLastName).subscribe(
      {
        next: (data: any) =>  {
          this.rowData = data;
          this.processDataforTable(data);
        },
        error: (err) => { console.log(err); }
      });
  }

  processDataforTable(data: any) {
    this.cleanData = data.map((item: any) => {
      const container: any = {};
      container.empFullName = _.startCase(_.toLower(((!_.isEmpty(item.employeeFname)) ? item.employeeFname : '') +
                            ((!_.isEmpty(item.employeeMi)) ? (' ' + item.employeeMi) : ' ')  +
                            ((!_.isEmpty(item.employeeLname)) ? item.employeeLname : '')));
      container.empPhone = ((!_.isEmpty(item.employeePhoneExt)) ? ((item.employeePhoneExt === '0' || item.employeePhoneExt === 0) ? '' : item.employeePhoneExt) : ' ') +
                            ((!_.isEmpty(item.employeePhone)) ? item.employeePhone : ' ');
      container.empEmail = (!_.isEmpty(item.employeeEmail)) ? (item.employeeEmail) : 'No Email';

      container.tspFullName =  _.startCase(_.toLower(((!_.isEmpty(item.tspContactFname)) ? item.tspContactFname : ' ') +
                              ((!_.isEmpty(item.tspContactMi)) ? item.tspContactMi : ' ') +
                              ((!_.isEmpty(item.tspContactLname)) ? item.tspContactLname : '')));
      container.tspEmail = (!_.isEmpty(item.tspContactEmail)) ? (item.tspContactEmail) : 'No Email';
      container.tspPhone = ((!_.isEmpty(item.tspContactPhoneExt)) ? ((item.tspContactPhoneExt === 0) ? '' : item.tspContactPhoneExt) : ' ') +
                           ((!_.isEmpty(item.tspContactPhone)) ? item.tspContactPhone : '');

      container.amcFullName = _.startCase(_.toLower((((!_.isEmpty(item.amcFname)) ? item.amcFname : ' ') +
                              ((!_.isEmpty(item.amcMi)) ? ' ' + item.amcMi : ' ') +
                              ((!_.isEmpty(item.amcLname)) ? item.amcLname : ' ')))) ;
      container.amcEmail = (!_.isEmpty(item.amcEmail)) ? (item.amcEmail) : 'No Email';
      container.amcPhone = ((!_.isEmpty(item.amcContactPhoneExt)) ? ((item.amcContactPhoneExt === 0) ? '' : item.amcContactPhoneExt) : ' ') +
                           ((!_.isEmpty(item.amcPhone)) ? item.amcPhone : ' ');

      container.bolNumber = (!_.isEmpty(item.bolNumber)) ? _.lowerCase(item.bolNumber) : 'No BOL';
      container.surveyNumber = item.surveyNumber;
      container.status = item.status;
      return container;
    });
  }

  initializedColDef() {
    this.listSurveybyLastName = [
      {
        headerName: 'Employee Details',
        children: [
          {
            headerName: 'Employee Full Name',
            field: 'empFullName',
            width: 180,
            filter: 'agTextColumnFilter'
          },
          {
            headerName: 'Employee Phone',
            field: 'empPhone',
            width: 180,
            filter: 'agNumberColumnFilter'
          },
          {
            headerName: 'Employee Email',
            field: 'empEmail',
            width: 150,
            filter: 'agNumberColumnFilter'
          }
        ],
      },
      {
        headerName: 'Other Details',
        children: [
          {
            headerName: 'Survey Number',
            field: 'surveyNumber',
            filter: 'agTextColumnFilter',
            sortable: true,
            cellRenderer: (params: any) => {
              return (AppConstants.isNotNullCondition(params)) ?
                      '<a tabindex="0">' + params.data.surveyNumber + '</a>' : params.data.surveyNumber;
            },
            onCellClicked: (event: any) => this.onSurveyNo(event.data)
          },
          {
            headerName: 'BOL Number',
            field: 'bolNumber',
            filter: 'agTextColumnFilter',
            sortable: true
          },
          {
            headerName: 'Status',
            field: 'status',
            filter: 'agTextColumnFilter',
            sortable: true
          }
        ],
      },
      {
        headerName: 'TSP Contact',
        children: [
          {
            headerName: 'TSP Contact Name',
            field: 'tspFullName',
            width: 180,
            filter: 'agTextColumnFilter',
          },
          {
            headerName: 'TSP Contact Phone',
            field: 'tspPhone',
            width: 150,
            filter: 'agNumberColumnFilter',
          },
          {
            headerName: 'TSP Contact Email',
            field: 'tspEmail',
            width: 180,
            filter: 'agNumberColumnFilter',
          }
        ],
      },
      {
        headerName: 'AMC Details',
        children: [
          {
            headerName: 'AMC Name',
            field: 'amcFullName',
            width: 180,
            filter: 'agTextColumnFilter',
          },
          {
            headerName: 'AMC Phone',
            field: 'amcPhone',
            width: 150,
            filter: 'agNumberColumnFilter',
          },
          {
            headerName: 'AMC Email',
            field: 'amcEmail',
            width: 180,
            filter: 'agNumberColumnFilter',
          }
        ],
      }
    ];
    this.defaultColDef = { resizable: true };
    this.paginationPageSize = 25;
  }

}
